(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ho-contact-page"] && !Shopify.designMode) return;
  try {
    

(() => {
  const initialise = (root) => {
    if (!root || root.dataset.contactReady === 'true') return;
    root.dataset.contactReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-panel]'));
    const booking = root.querySelector('#HrBookingForm');
    const summary = root.querySelector('[data-booking-summary]');
    const panelHashes = {sales:'sales-enquiries', booking:'book-an-appointment', directory:'department-contacts'};
    const setPanel = (key, updateHash = false) => {
      if (!panels.some(panel => panel.dataset.panel === key)) return;
      tabs.forEach(tab => {
        const selected = tab.dataset.tab === key;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.panel !== key; });
      if (updateHash) history.replaceState(null, '', location.pathname + location.search + '#' + panelHashes[key]);
    };
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', () => setPanel(tab.dataset.tab, true));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[tabs.length - 1] : tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        setPanel(next.dataset.tab, true);
        next.focus();
      });
    });
    root.querySelectorAll('[data-switch]').forEach(button => button.addEventListener('click', () => {
      setPanel(button.dataset.switch, true);
      tabs.find(tab => tab.dataset.tab === button.dataset.switch)?.focus();
    }));
    const requested = location.hash.slice(1);
    let initial = Object.keys(panelHashes).find(key => panelHashes[key] === requested) || 'booking';
    if (requested === 'HrSalesForm') initial = 'sales';
    if (requested === 'HrBookingForm') initial = 'booking';
    let lastSubmitted;
    try {
      lastSubmitted = JSON.parse(sessionStorage.getItem('ho-contact-submission') || 'null');
      if (lastSubmitted && Date.now() - lastSubmitted.at < 600000 && root.querySelector('[data-form-success],[data-form-errors]')) initial = lastSubmitted.panel;
      sessionStorage.removeItem('ho-contact-submission');
    } catch (_) {}
    setPanel(initial);
    [root.querySelector('#HrSalesForm'), booking].forEach(form => {
      if (!form) return;
      form.addEventListener('submit', () => {
        try { sessionStorage.setItem('ho-contact-submission', JSON.stringify({panel:form.id === 'HrSalesForm' ? 'sales' : 'booking', at:Date.now()})); } catch (_) {}
      });
    });
    const notice = root.querySelector('[data-panel="' + initial + '"] [data-form-success],[data-panel="' + initial + '"] [data-form-errors]');
    if (notice) notice.focus();
    if (booking) {
      const dateInput = booking.elements.namedItem('contact[Preferred date]');
      const timeInput = booking.elements.namedItem('contact[Preferred time]');
      const now = new Date();
      dateInput.min = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2,'0') + '-' + String(now.getDate()).padStart(2,'0');
      const updateSummary = () => {
        const person = booking.querySelector('input[name="contact[Staff preference]"]:checked')?.value || 'No preference';
        const who = person === 'No preference' ? 'Our team' : person;
        summary.textContent = dateInput.value && timeInput.value ? who + ' · ' + new Date(dateInput.value + 'T12:00:00').toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short'}) + ' · ' + timeInput.value : person === 'No preference' ? 'Choose your preferred date and time above.' : who + ' · choose your preferred date and time above.';
      };
      booking.addEventListener('input', updateSummary);
      booking.addEventListener('change', updateSummary);
      updateSummary();
    }
    const gallery = root.querySelector('.hr-visit-gallery');
    const visitImages = {
      entrance: {label:'Satellite · entrance',alt:'Wider satellite view of Main Road, nearby fields and the nursery entrance beside the neighbouring houses',caption:'Enter from Main Road via the gravel driveway beside the white house.'},
      nursery: {label:'Satellite · full nursery',alt:'Satellite view showing the full Harrod Outdoors nursery',caption:'The full nursery, with the access drive leading in from Main Road.'},
      street: {label:'Street view · entrance',alt:'Street view of the gravel nursery entrance beside the white house on Main Road',caption:'Look for the gravel drive beside the white house and follow it into the nursery.'}
    };
    const showVisit = name => {
      const copy = visitImages[name];
      const thumbnail = gallery.querySelector('[data-visit-thumb="' + name + '"]');
      if (!copy || !thumbnail) return;
      const image = gallery.querySelector('[data-visit-main]');
      image.src = thumbnail.src;
      image.alt = copy.alt;
      gallery.querySelector('.hr-map').style.setProperty('--hr-map-ratio', thumbnail.getAttribute('width') + '/' + thumbnail.getAttribute('height'));
      gallery.querySelector('[data-visit-label]').textContent = copy.label;
      gallery.querySelector('[data-visit-caption]').textContent = copy.caption;
      gallery.querySelector('.hr-map-pin').hidden = name !== 'entrance';
      gallery.querySelectorAll('[data-visit]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.visit === name)));
    };
    gallery.querySelectorAll('[data-visit]').forEach(button => button.addEventListener('click',() => showVisit(button.dataset.visit)));
    showVisit('entrance');
  };
  initialise(document.getElementById('harrod-refined-contact'));
  document.addEventListener('shopify:section:load', event => initialise(event.target.querySelector('#harrod-refined-contact')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ho-pleached-red-robin"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.hoReady === 'true') return;
    root.dataset.hoReady = 'true';
    const input = root.querySelector('.ho-prr__range');
    const compare = root.querySelector('.ho-prr__compare');
    if (!input || !compare) return;
    const update = () => {
      compare.style.setProperty('--split', `${input.value}%`);
      input.setAttribute('aria-valuetext', root.dataset.rangeTemplate.replace('__VALUE__', input.value));
    };
    const point = event => {
      const bounds = compare.getBoundingClientRect();
      input.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100))));
      update();
    };
    input.addEventListener('input', update);
    input.addEventListener('pointerdown', event => {
      if (event.button !== 0) return;
      event.preventDefault();
      input.focus({ preventScroll: true });
      input.setPointerCapture(event.pointerId);
      point(event);
    });
    input.addEventListener('pointermove', event => {
      if (input.hasPointerCapture(event.pointerId)) point(event);
    });
    input.addEventListener('pointerup', event => {
      if (input.hasPointerCapture(event.pointerId)) input.releasePointerCapture(event.pointerId);
    });
    update();
  };
  const scan = container => container.querySelectorAll('[data-ho-pleached-red-robin]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ho-underplanting-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
 function init(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  function tabs(buttons, panels) {
   function select(button) {
    buttons.forEach(item => { item.setAttribute('aria-selected', String(item === button)); item.tabIndex = item === button ? 0 : -1; });
    panels.forEach(panel => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
   }
   buttons.forEach((button, index) => {
    button.addEventListener('click', () => select(button));
    button.addEventListener('keydown', event => {
     let next;
     if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
     else if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
     else if (event.key === 'Home') next = 0;
     else if (event.key === 'End') next = buttons.length - 1;
     else return;
     event.preventDefault(); select(buttons[next]); buttons[next].focus();
    });
   });
   return select;
  }
  const styleButtons = [...root.querySelectorAll('[data-style]')];
  tabs(styleButtons, [...root.querySelectorAll('.ho-up-comparison-panel')]);
  tabs([...root.querySelectorAll('[data-renewal]')], [...root.querySelectorAll('.ho-up-renewal-panel')]);
  tabs([...root.querySelectorAll('[data-guide]')], [...root.querySelectorAll('.ho-up-guide-panel')]);
  root.querySelectorAll('.ho-up-compare input').forEach(input => input.addEventListener('input', () => {
   input.closest('.ho-up-compare').style.setProperty('--split', input.value + '%');
   input.setAttribute('aria-valuetext', root.dataset.rangeTemplate.replace('__VALUE__', input.value));
  }));
 }
 document.querySelectorAll('.ho-up').forEach(init);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ho-up').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ho-welcome-offer"]) return;
  try {
    
  (()=>{
    const init=()=>document.querySelectorAll('[data-welcome-offer]').forEach(root=>{
      if(root.dataset.welcomeReady)return;
      root.dataset.welcomeReady='true';
      const button=root.querySelector('[data-welcome-copy]');
      const input=root.querySelector('[data-welcome-code]');
      const status=root.querySelector('[data-welcome-status]');
      if(!button||!input||!status)return;
      button.addEventListener('click',async()=>{
        button.disabled=true;
        let copied=false;
        try{
          if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(input.value);copied=true;}
        }catch(error){copied=false;}
        if(!copied){
          input.focus();input.select();input.setSelectionRange(0,input.value.length);
          try{copied=document.execCommand('copy');}catch(error){copied=false;}
        }
        status.textContent=copied?button.dataset.success:button.dataset.fallback;
        button.disabled=false;
        if(copied)button.focus();
      });
    });
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-header"]) return;
  try {
    
// Remove only the decorative Shop avatar ring; the account button keeps its native focus treatment.
(() => {
  if (window.HarrodAccountAvatar) return;
  window.HarrodAccountAvatar = true;
  const watched = new WeakSet();
  const styleAvatar = (account) => {
    const root = account.shadowRoot;
    if (!root) return;
    const apply = () => {
      if (root.querySelector('[data-ho-avatar-style]')) return;
      const style = document.createElement('style');
      style.dataset.hoAvatarStyle = '';
      style.textContent = '.account-button--shop-customer { --ring-width: 0px !important; }';
      root.append(style);
    };
    apply();
    if (!watched.has(root)) {
      watched.add(root);
      new MutationObserver(apply).observe(root, { childList: true });
    }
  };
  const scan = () => document.querySelectorAll('.site-header shopify-account').forEach(styleAvatar);
  customElements.whenDefined('shopify-account').then(() => {
    scan();
    requestAnimationFrame(scan);
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
